import React from "react";
import styled from "styled-components";
import media from "@ui/utils/media";
import {Trash} from "@styled-icons/boxicons-regular/Trash";
import {Plus} from "@styled-icons/boxicons-regular/Plus";
import {Minus} from "@styled-icons/boxicons-regular/Minus";
import {ShoppingCartOutline} from "@styled-icons/evaicons-outline/ShoppingCartOutline";
import {ArrowBack} from "@styled-icons/boxicons-regular/ArrowBack";
import {ArrowUpRight} from "@styled-icons/bootstrap/ArrowUpRight";
import {CheckCircle} from "@styled-icons/boxicons-regular/CheckCircle";
import {ChevronDown} from "@styled-icons/bootstrap/ChevronDown";
import {ChevronRight} from "@styled-icons/bootstrap/ChevronRight";
import {ChevronLeft} from "@styled-icons/bootstrap/ChevronLeft";
import {Store} from "@styled-icons/boxicons-regular/Store";
import {Car} from "@styled-icons/boxicons-regular/Car";
import {X} from "@styled-icons/bootstrap/X";
import {Cannabis} from "@styled-icons/fa-solid/Cannabis";
import {User} from "@styled-icons/boxicons-regular/User";
import {CheckCircleFill} from "@styled-icons/bootstrap/CheckCircleFill";
import {SearchOutline} from "@styled-icons/evaicons-outline";

const size = ({size}) => size || "16px";
const color = ({color}) => color || "#272727";
const padding = ({padding}) => padding || "0px 0px 0px 6px";
const margin = ({margin}) => margin || "0px";
const display = ({display}) => display || "";

export const TrashIcon = styled(Trash).attrs(() => ({
  "data-keep-cart": "true",
}))`
  min-width: ${size};
  min-height: ${size};
  width: ${size};
  height: ${size};
  color: ${color};
`;

export const PlusIcon = styled(Plus).attrs(() => ({
  "data-keep-cart": "true",
}))`
  min-width: ${size};
  min-height: ${size};
  width: ${size};
  height: ${size};
  color: ${color};
`;

export const MinusIcon = styled(Minus).attrs(() => ({
  "data-keep-cart": "true",
}))`
  min-width: ${size};
  min-height: ${size};
  width: ${size};
  height: ${size};
  color: ${color};
`;

export const CartIcon = styled(ShoppingCartOutline).attrs(() => ({
  "data-keep-cart": "true",
}))`
  min-width: ${size};
  min-height: ${size};
  width: ${size};
  height: ${size};
  color: ${color};
  display: ${display};
  cursor: pointer;
  ${media.up("md")} {
    display: ${({hideIconInLargerViewport}) =>
      hideIconInLargerViewport ? "none" : "block"};
  }
`;

export const CheckCircleIcon = styled(CheckCircle).attrs(() => ({
  "data-keep-cart": "true",
}))`
  min-width: ${size};
  min-height: ${size};
  width: ${size};
  height: ${size};
  color: ${color};
`;

export const BackIcon = styled(ArrowBack)`
  min-width: ${size};
  min-height: ${size};
  width: ${size};
  height: ${size};
  color: ${color};
`;

export const ArrowUpRightIcon = styled(ArrowUpRight)`
  min-width: ${size};
  min-height: ${size};
  width: ${size};
  height: ${size};
  color: ${color};
`;

export const ChevronDownIcon = styled(ChevronDown)`
  min-width: ${size};
  min-height: ${size};
  width: ${size};
  height: ${size};
  color: ${color};
  padding: ${padding};
`;

export const ChevronRightIcon = styled(ChevronRight)`
  min-width: ${size};
  min-height: ${size};
  width: ${size};
  height: ${size};
  color: ${color};
  padding: ${padding};
`;

export const ChevronLeftIcon = styled(ChevronLeft)`
  min-width: ${size};
  min-height: ${size};
  width: ${size};
  height: ${size};
  color: ${color};
  padding: ${padding};
`;

export const CloseIcon = styled(X)`
  min-width: ${size};
  min-height: ${size};
  width: ${size};
  height: ${size};
  color: ${color};
  margin: ${margin};
`;

export const PickupIcon = styled(Store)`
  min-width: ${size};
  min-height: ${size};
  width: ${size};
  height: ${size};
  color: ${color};
  margin: ${margin};
`;

export const DeliveryIcon = styled(Car)`
  min-width: ${size};
  min-height: ${size};
  width: ${size};
  height: ${size};
  color: ${color};
  margin: ${margin};
`;

export const CheckmarkIcon = styled(CheckCircleFill)`
  min-width: ${size};
  min-height: ${size};
  width: ${size};
  height: ${size};
  color: ${color};
  margin: ${margin};
`;

export const RecreationalIcon = styled(Cannabis)`
  min-width: ${size};
  min-height: ${size};
  width: ${size};
  height: ${size};
  color: ${color};
  margin: ${margin};
`;

export const SearchIcon = styled(SearchOutline).attrs(() => ({
  className: "search-btn search-btn__icon",
}))`
  height: 24px;
  cursor: pointer;
  color: ${color};
`;

export const FiltersIcon = (props) => {
  const styles = {
    transform: "rotateZ(90deg)",
    minWidth: size(props),
    minHeight: size(props),
    color: color(props),
    width: size(props),
    height: size(props),
    margin: margin(props),
  };
  return (
    <svg
      style={styles}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 6V4m0 2a2 2 0 1 0 0 4m0-4a2 2 0 1 1 0 4m-6 8a2 2 0 1 0 0-4m0 4a2 2 0 1 1 0-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 1 0 0-4m0 4a2 2 0 1 1 0-4m0 4v2m0-6V4"
      />
    </svg>
  );
};

const BoldSearchIcon = ({color = "black"}) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.23438 0.75C10.3893 0.75 12.4559 1.60602 13.9796 3.12976C15.5034 4.65349 16.3594 6.72012 16.3594 8.875C16.3594 10.8875 15.6219 12.7375 14.4094 14.1625L14.7469 14.5H15.7344L21.9844 20.75L20.1094 22.625L13.8594 16.375V15.3875L13.5219 15.05C12.0969 16.2625 10.2469 17 8.23438 17C6.07949 17 4.01287 16.144 2.48913 14.6202C0.965399 13.0965 0.109375 11.0299 0.109375 8.875C0.109375 6.72012 0.965399 4.65349 2.48913 3.12976C4.01287 1.60602 6.07949 0.75 8.23438 0.75ZM8.23438 3.25C5.10938 3.25 2.60938 5.75 2.60938 8.875C2.60938 12 5.10938 14.5 8.23438 14.5C11.3594 14.5 13.8594 12 13.8594 8.875C13.8594 5.75 11.3594 3.25 8.23438 3.25Z"
        fill={color}
      />
    </svg>
  );
};

const ShoppingBag = () => {
  return (
    <svg
      width="20"
      height="23"
      viewBox="0 0 22 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1811 4.89255H21.3707V26H0.403076V4.89255H5.59009C5.8039 2.15496 8.0931 0.00012207 10.8856 0.00012207C13.6781 0.00012207 15.9673 2.15496 16.1811 4.89255ZM14.1386 4.89255C13.9327 3.27935 12.5547 2.03238 10.8856 2.03238C9.21642 2.03238 7.8385 3.27935 7.63259 4.89255H14.1386ZM2.36006 6.84953H19.4137V24.043H2.36006V6.84953Z"
        fill="white"
      />
    </svg>
  );
};

const ShoppingBagAdd = () => {
  return (
    <svg
      width="28"
      height="60"
      viewBox="0 0 23 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9983 5.08056H22.3869V26.9999H0.612793V5.08056H5.99998C6.22204 2.2377 8.59928 0 11.4992 0C14.399 0 16.7763 2.2377 16.9983 5.08056ZM14.9561 5.08056C14.7417 3.36205 13.2757 2.03225 11.4992 2.03225C9.72258 2.03225 8.25659 3.36205 8.04225 5.08056H14.9561ZM2.64505 7.11282H20.3547V24.9676H2.64505V7.11282ZM10.4837 10.5968V15.0967H6.27432V16.9838H10.4837V21.1935H12.3708V16.9838H16.7259V15.0967H12.3708V10.5968H10.4837Z"
        fill="white"
      />
    </svg>
  );
};

const ShoppingBagAddPlus = () => {
  return (
    <svg
      width="23"
      height="25"
      viewBox="0 0 23 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5557 6.50331C17.5557 3.17008 14.8439 0.458252 11.5106 0.458252C8.17734 0.458252 5.46556 3.17008 5.46556 6.50331H0.931763V20.8603C0.931763 22.947 2.62329 24.6385 4.70993 24.6385H18.3113C20.3979 24.6385 22.0895 22.947 22.0895 20.8603V6.50331H17.5557ZM11.5106 1.96952C14.0106 1.96952 16.0444 4.00335 16.0444 6.50331H6.97682C6.97682 4.00335 9.01066 1.96952 11.5106 1.96952ZM20.5782 20.8603C20.5782 22.1103 19.5613 23.1272 18.3113 23.1272H4.70993C3.45997 23.1272 2.44303 22.1103 2.44303 20.8603V8.01458H5.46556V10.2815C5.46556 10.6988 5.80389 11.0371 6.22119 11.0371C6.63849 11.0371 6.97682 10.6988 6.97682 10.2815V8.01458H16.0444V10.2815C16.0444 10.6988 16.3827 11.0371 16.8 11.0371C17.2174 11.0371 17.5557 10.6988 17.5557 10.2815V8.01458H20.5782V20.8603Z"
        fill="white"
      />
      <path
        d="M15.615 15.2518H12.0983V11.7352C12.0983 11.638 12.0196 11.5594 11.9225 11.5594H11.2191C11.122 11.5594 11.0433 11.638 11.0433 11.7352V15.2518H7.52666C7.42951 15.2518 7.35083 15.3305 7.35083 15.4277V16.131C7.35083 16.2282 7.42951 16.3068 7.52666 16.3068H11.0433V19.8235C11.0433 19.9206 11.122 19.9993 11.2191 19.9993H11.9225C12.0196 19.9993 12.0983 19.9206 12.0983 19.8235V16.3068H15.615C15.7121 16.3068 15.7908 16.2282 15.7908 16.131V15.4277C15.7908 15.3305 15.7121 15.2518 15.615 15.2518Z"
        fill="white"
      />
    </svg>
  );
};

const ShoppingBagWithCurve = () => {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.4297 7.5H21.9297C21.9297 4 19.1797 1.25 15.6797 1.25C12.1797 1.25 9.42969 4 9.42969 7.5H6.92969C5.55469 7.5 4.42969 8.625 4.42969 10V25C4.42969 26.375 5.55469 27.5 6.92969 27.5H24.4297C25.8047 27.5 26.9297 26.375 26.9297 25V10C26.9297 8.625 25.8047 7.5 24.4297 7.5ZM15.6797 3.75C17.8047 3.75 19.4297 5.375 19.4297 7.5H11.9297C11.9297 5.375 13.5547 3.75 15.6797 3.75ZM24.4297 25H6.92969V10H24.4297V25ZM15.6797 15C13.5547 15 11.9297 13.375 11.9297 11.25H9.42969C9.42969 14.75 12.1797 17.5 15.6797 17.5C19.1797 17.5 21.9297 14.75 21.9297 11.25H19.4297C19.4297 13.375 17.8047 15 15.6797 15Z"
        fill="black"
      />
    </svg>
  );
};

export const CaretDown = () => {
  return (
    <svg
      width="10"
      height="5"
      viewBox="0 0 10 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0L5 5L10 0H0Z" fill="white" />
    </svg>
  );
};

export const MapPin = () => {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 7.625C5.50272 7.625 5.02581 7.42746 4.67417 7.07583C4.32254 6.72419 4.125 6.24728 4.125 5.75C4.125 5.25272 4.32254 4.77581 4.67417 4.42417C5.02581 4.07254 5.50272 3.875 6 3.875C6.49728 3.875 6.97419 4.07254 7.32583 4.42417C7.67746 4.77581 7.875 5.25272 7.875 5.75C7.875 5.99623 7.8265 6.24005 7.73227 6.46753C7.63805 6.69502 7.49994 6.90172 7.32583 7.07583C7.15172 7.24994 6.94502 7.38805 6.71753 7.48227C6.49005 7.5765 6.24623 7.625 6 7.625ZM6 0.5C4.60761 0.5 3.27226 1.05312 2.28769 2.03769C1.30312 3.02226 0.75 4.35761 0.75 5.75C0.75 9.6875 6 15.5 6 15.5C6 15.5 11.25 9.6875 11.25 5.75C11.25 4.35761 10.6969 3.02226 9.71231 2.03769C8.72774 1.05312 7.39239 0.5 6 0.5Z"
        fill="white"
      />
    </svg>
  );
};

const UserIcon = styled(User).attrs(() => ({
  className: "login-btn login-btn__icon",
}))`
  min-width: ${size};
  min-height: ${size};
  width: ${size};
  height: ${size};
  color: ${color};
  margin: ${margin};
  cursor: pointer;
`;

const FilledUserIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 34 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="34" height="33" fill="url(#pattern0)" />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_1356_4010"
            transform="translate(-0.231809 -0.54) scale(0.0244283 0.0254054)"
          />
        </pattern>
        <image
          id="image0_1356_4010"
          width="178"
          height="74"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};

const RoundedUserIcon = () => {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3594 2.5C13.7179 2.5 12.0924 2.82332 10.5758 3.45151C9.05926 4.07969 7.68127 5.00043 6.52054 6.16117C4.17634 8.50537 2.85938 11.6848 2.85938 15C2.85938 18.3152 4.17634 21.4946 6.52054 23.8388C7.68127 24.9996 9.05926 25.9203 10.5758 26.5485C12.0924 27.1767 13.7179 27.5 15.3594 27.5C18.6746 27.5 21.854 26.183 24.1982 23.8388C26.5424 21.4946 27.8594 18.3152 27.8594 15C27.8594 13.3585 27.5361 11.733 26.9079 10.2165C26.2797 8.69989 25.3589 7.3219 24.1982 6.16117C23.0375 5.00043 21.6595 4.07969 20.1429 3.45151C18.6263 2.82332 17.0009 2.5 15.3594 2.5ZM9.19688 22.85C9.73438 21.725 13.0094 20.625 15.3594 20.625C17.7094 20.625 20.9844 21.725 21.5219 22.85C19.8219 24.2 17.6844 25 15.3594 25C13.0344 25 10.8969 24.2 9.19688 22.85ZM23.3094 21.0375C21.5219 18.8625 17.1844 18.125 15.3594 18.125C13.5344 18.125 9.19687 18.8625 7.40937 21.0375C6.13437 19.375 5.35938 17.275 5.35938 15C5.35938 9.4875 9.84688 5 15.3594 5C20.8719 5 25.3594 9.4875 25.3594 15C25.3594 17.275 24.5844 19.375 23.3094 21.0375ZM15.3594 7.5C12.9344 7.5 10.9844 9.45 10.9844 11.875C10.9844 14.3 12.9344 16.25 15.3594 16.25C17.7844 16.25 19.7344 14.3 19.7344 11.875C19.7344 9.45 17.7844 7.5 15.3594 7.5ZM15.3594 13.75C14.8621 13.75 14.3852 13.5525 14.0335 13.2008C13.6819 12.8492 13.4844 12.3723 13.4844 11.875C13.4844 11.3777 13.6819 10.9008 14.0335 10.5492C14.3852 10.1975 14.8621 10 15.3594 10C15.8567 10 16.3336 10.1975 16.6852 10.5492C17.0368 10.9008 17.2344 11.3777 17.2344 11.875C17.2344 12.3723 17.0368 12.8492 16.6852 13.2008C16.3336 13.5525 15.8567 13.75 15.3594 13.75Z"
        fill="black"
      />
    </svg>
  );
};

export function getCartIconComponent(iconName) {
  switch (iconName) {
    case "empty":
      return "empty";
    case "bag":
      return ShoppingBag;
    case "bag-add":
      return ShoppingBagAdd;
    case "bag-add-plus":
      return ShoppingBagAddPlus;
    case "bag-with-curve":
      return ShoppingBagWithCurve;
    default:
      return CartIcon;
  }
}

export function getUserIconComponent(iconName) {
  switch (iconName) {
    case "filled":
      return FilledUserIcon;
    case "rounded":
      return RoundedUserIcon;
    default:
      return UserIcon;
  }
}

export function getSearchIconComponent(iconName) {
  switch (iconName) {
    case "bold-search-icon":
      return BoldSearchIcon;
    default:
      return SearchIcon;
  }
}
